import {$util} from '@/lib'
// 按钮权限指令
const has = {
    inserted: (el, binding) => {
        // 如果编码为空则始终显示
        if (!binding.value) return

        //验证按钮权限
        if (!$util.basic.auth.hasPermission(binding.value)) {
            el.parentNode.removeChild(el)
        }
    }
}

export default {
    name: 'Has',
    directive: has
}